import React from "react";

export function SVGLinkArrow() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_903_143217)">
        <rect width="12" height="12" fill="white" fillOpacity="0.01" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.48419 1.23322C3.51903 1.19829 3.56041 1.17059 3.60597 1.15168C3.65153 1.13278 3.70037 1.12305 3.74969 1.12305C3.79902 1.12305 3.84786 1.13278 3.89342 1.15168C3.93898 1.17059 3.98036 1.19829 4.01519 1.23322L8.51519 5.73322C8.55012 5.76805 8.57782 5.80943 8.59673 5.85499C8.61563 5.90055 8.62536 5.94939 8.62536 5.99872C8.62536 6.04804 8.61563 6.09688 8.59673 6.14244C8.57782 6.188 8.55012 6.22938 8.51519 6.26422L4.01519 10.7642C3.94478 10.8346 3.84928 10.8742 3.74969 10.8742C3.65011 10.8742 3.55461 10.8346 3.48419 10.7642C3.41378 10.6938 3.37422 10.5983 3.37422 10.4987C3.37422 10.3991 3.41378 10.3036 3.48419 10.2332L7.71944 5.99872L3.48419 1.76422C3.44927 1.72938 3.42156 1.688 3.40266 1.64244C3.38375 1.59688 3.37402 1.54804 3.37402 1.49872C3.37402 1.44939 3.38375 1.40055 3.40266 1.35499C3.42156 1.30943 3.44927 1.26805 3.48419 1.23322Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_903_143217">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SVGUnion() {
  return (
    <svg
      className="object-contain h-full w-full"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0039 22.501C9.21913 22.501 6.54842 21.3947 4.57928 19.4256C2.61015 17.4565 1.50391 14.7858 1.50391 12.001C1.50391 9.2162 2.61015 6.54549 4.57928 4.57635C6.54842 2.60722 9.21913 1.50098 12.0039 1.50098C14.7887 1.50098 17.4594 2.60722 19.4285 4.57635C21.3977 6.54549 22.5039 9.2162 22.5039 12.001C22.5039 14.7858 21.3977 17.4565 19.4285 19.4256C17.4594 21.3947 14.7887 22.501 12.0039 22.501ZM12.0039 24.001C15.1865 24.001 18.2388 22.7367 20.4892 20.4863C22.7396 18.2358 24.0039 15.1836 24.0039 12.001C24.0039 8.81838 22.7396 5.76613 20.4892 3.5157C18.2388 1.26526 15.1865 0.000976563 12.0039 0.000976562C8.82131 0.000976563 5.76906 1.26526 3.51863 3.5157C1.26819 5.76613 0.00390625 8.81838 0.00390625 12.001C0.00390625 15.1836 1.26819 18.2358 3.51863 20.4863C5.76906 22.7367 8.82131 24.001 12.0039 24.001Z"
        fill="#EC1C2C"
      />
      <path
        d="M10.5069 16.501C10.5069 16.304 10.5457 16.1089 10.6211 15.927C10.6965 15.745 10.807 15.5796 10.9462 15.4403C11.0855 15.301 11.2509 15.1905 11.4329 15.1152C11.6149 15.0398 11.8099 15.001 12.0069 15.001C12.2039 15.001 12.3989 15.0398 12.5809 15.1152C12.7629 15.1905 12.9283 15.301 13.0676 15.4403C13.2069 15.5796 13.3173 15.745 13.3927 15.927C13.4681 16.1089 13.5069 16.304 13.5069 16.501C13.5069 16.8988 13.3489 17.2803 13.0676 17.5616C12.7863 17.8429 12.4047 18.001 12.0069 18.001C11.6091 18.001 11.2276 17.8429 10.9462 17.5616C10.6649 17.2803 10.5069 16.8988 10.5069 16.501ZM10.6539 7.49348C10.6339 7.30424 10.654 7.11291 10.7127 6.93192C10.7714 6.75092 10.8676 6.5843 10.9949 6.44286C11.1222 6.30142 11.2778 6.18832 11.4516 6.1109C11.6255 6.03348 11.8136 5.99348 12.0039 5.99348C12.1942 5.99348 12.3824 6.03348 12.5562 6.1109C12.73 6.18832 12.8856 6.30142 13.0129 6.44286C13.1402 6.5843 13.2364 6.75092 13.2951 6.93192C13.3538 7.11291 13.3739 7.30424 13.3539 7.49348L12.8289 12.754C12.8113 12.9606 12.7167 13.1531 12.5639 13.2934C12.4112 13.4337 12.2113 13.5116 12.0039 13.5116C11.7965 13.5116 11.5966 13.4337 11.4439 13.2934C11.2911 13.1531 11.1965 12.9606 11.1789 12.754L10.6539 7.49348Z"
        fill="#EC1C2C"
      />
    </svg>
  );
}

export function USAFlag() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16 2.66656H0V13.3333H16V2.66656Z" fill="#F0F0F0" />
      <path d="M16 3.99982H0V5.33304H16V3.99982Z" fill="#D80027" />
      <path d="M16 6.66663H0V7.99985H16V6.66663Z" fill="#D80027" />
      <path d="M16 9.33301H0V10.6662H16V9.33301Z" fill="#D80027" />
      <path d="M16 11.9998H0V13.333H16V11.9998Z" fill="#D80027" />
      <path d="M8 2.66656H0V8.41022H8V2.66656Z" fill="#2E52B2" />
      <path
        d="M3.11981 5.01947L2.99097 5.41585H2.57422L2.91144 5.66069L2.78259 6.05703L3.11981 5.81219L3.45681 6.05703L3.328 5.66069L3.66522 5.41585H3.24844L3.11981 5.01947Z"
        fill="#F0F0F0"
      />
      <path
        d="M3.24844 6.84623L3.11981 6.44989L2.99097 6.84623H2.57422L2.91144 7.09111L2.78259 7.48745L3.11981 7.24258L3.45681 7.48745L3.328 7.09111L3.66522 6.84623H3.24844Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.48675 6.84623L1.35809 6.44989L1.22925 6.84623H0.8125L1.14972 7.09111L1.02087 7.48745L1.35809 7.24258L1.69512 7.48745L1.56631 7.09111L1.90347 6.84623H1.48675Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.35809 5.01947L1.22925 5.41585H0.8125L1.14972 5.66069L1.02087 6.05703L1.35809 5.81219L1.69512 6.05703L1.56631 5.66069L1.90347 5.41585H1.48675L1.35809 5.01947Z"
        fill="#F0F0F0"
      />
      <path
        d="M3.11981 3.58905L2.99097 3.98546H2.57422L2.91144 4.23033L2.78259 4.62668L3.11981 4.3818L3.45681 4.62668L3.328 4.23033L3.66522 3.98546H3.24844L3.11981 3.58905Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.35809 3.58905L1.22925 3.98546H0.8125L1.14972 4.23033L1.02087 4.62668L1.35809 4.3818L1.69512 4.62668L1.56631 4.23033L1.90347 3.98546H1.48675L1.35809 3.58905Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.8815 5.01947L4.75269 5.41585H4.33594L4.67312 5.66069L4.54434 6.05703L4.8815 5.81219L5.21856 6.05703L5.08972 5.66069L5.42694 5.41585H5.01019L4.8815 5.01947Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.01019 6.84623L4.8815 6.44989L4.75269 6.84623H4.33594L4.67312 7.09111L4.54434 7.48745L4.8815 7.24258L5.21856 7.48745L5.08972 7.09111L5.42694 6.84623H5.01019Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.77187 6.84623L6.64322 6.44989L6.51438 6.84623H6.09766L6.43481 7.09111L6.306 7.48745L6.64322 7.24258L6.98025 7.48745L6.85141 7.09111L7.18862 6.84623H6.77187Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.64322 5.01947L6.51438 5.41585H6.09766L6.43481 5.66069L6.306 6.05703L6.64322 5.81219L6.98025 6.05703L6.85141 5.66069L7.18862 5.41585H6.77187L6.64322 5.01947Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.8815 3.58905L4.75269 3.98546H4.33594L4.67312 4.23033L4.54434 4.62668L4.8815 4.3818L5.21856 4.62668L5.08972 4.23033L5.42694 3.98546H5.01019L4.8815 3.58905Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.64322 3.58905L6.51438 3.98546H6.09766L6.43481 4.23033L6.306 4.62668L6.64322 4.3818L6.98025 4.62668L6.85141 4.23033L7.18862 3.98546H6.77187L6.64322 3.58905Z"
        fill="#F0F0F0"
      />
    </svg>
  );
}

export function SVGMail() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" fill="white" fillOpacity="0.01" />
      <g clipPath="url(#clip0_946_155099)">
        <rect
          width="14"
          height="14"
          transform="translate(1 1)"
          fill="white"
          fillOpacity="0.01"
        />
        <g clipPath="url(#clip1_946_155099)">
          <path
            d="M1 4.49915C1 4.03502 1.18437 3.5899 1.51256 3.26171C1.84075 2.93352 2.28587 2.74915 2.75 2.74915H13.25C13.7141 2.74915 14.1592 2.93352 14.4874 3.26171C14.8156 3.5899 15 4.03502 15 4.49915V11.4991C15 11.9633 14.8156 12.4084 14.4874 12.7366C14.1592 13.0648 13.7141 13.2491 13.25 13.2491H2.75C2.28587 13.2491 1.84075 13.0648 1.51256 12.7366C1.18437 12.4084 1 11.9633 1 11.4991V4.49915ZM2.75 3.62415C2.51794 3.62415 2.29538 3.71633 2.13128 3.88043C1.96719 4.04452 1.875 4.26708 1.875 4.49915V4.68902L8 8.36402L14.125 4.68902V4.49915C14.125 4.26708 14.0328 4.04452 13.8687 3.88043C13.7046 3.71633 13.4821 3.62415 13.25 3.62415H2.75ZM14.125 5.70927L10.0055 8.18115L14.125 10.716V5.70927ZM14.0952 11.7258L9.16025 8.68865L8 9.38427L6.83975 8.68865L1.90475 11.7249C1.95447 11.9111 2.06428 12.0757 2.21712 12.1931C2.36996 12.3105 2.55728 12.3741 2.75 12.3741H13.25C13.4426 12.3742 13.6298 12.3106 13.7827 12.1934C13.9355 12.0762 14.0454 11.9118 14.0952 11.7258ZM1.875 10.716L5.9945 8.18115L1.875 5.70927V10.716Z"
            fill="#6C757D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_946_155099">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
        <clipPath id="clip1_946_155099">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SVGCheck() {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.17601 13.1417L0.351006 8.19169C-0.548994 5.85169 1.38601 5.04169 2.82601 6.39169L5.30101 9.54169L12.951 0.991688C14.301 -0.425812 16.551 0.384188 15.651 2.56669L6.65101 12.9167C5.68351 14.0417 4.85101 13.8167 4.17601 13.1417Z"
        fill="#198754"
      />
    </svg>
  );
}

//Application form

export function SVGJobVacancy() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_429_290110)">
        <path
          d="M9.75 1.5C9.15326 1.5 8.58097 1.73705 8.15901 2.15901C7.73705 2.58097 7.5 3.15326 7.5 3.75V4.5H2.25C1.65326 4.5 1.08097 4.73705 0.65901 5.15901C0.237053 5.58097 0 6.15326 0 6.75L0 18.75C0 19.3467 0.237053 19.919 0.65901 20.341C1.08097 20.7629 1.65326 21 2.25 21H21.75C22.3467 21 22.919 20.7629 23.341 20.341C23.7629 19.919 24 19.3467 24 18.75V6.75C24 6.15326 23.7629 5.58097 23.341 5.15901C22.919 4.73705 22.3467 4.5 21.75 4.5H16.5V3.75C16.5 3.15326 16.2629 2.58097 15.841 2.15901C15.419 1.73705 14.8467 1.5 14.25 1.5H9.75ZM9.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75V4.5H9V3.75C9 3.55109 9.07902 3.36032 9.21967 3.21967C9.36032 3.07902 9.55109 3 9.75 3ZM12.579 13.371L22.5 10.7265V18.75C22.5 18.9489 22.421 19.1397 22.2803 19.2803C22.1397 19.421 21.9489 19.5 21.75 19.5H2.25C2.05109 19.5 1.86032 19.421 1.71967 19.2803C1.57902 19.1397 1.5 18.9489 1.5 18.75V10.725L11.421 13.371C11.8004 13.472 12.1996 13.472 12.579 13.371ZM2.25 6H21.75C21.9489 6 22.1397 6.07902 22.2803 6.21967C22.421 6.36032 22.5 6.55109 22.5 6.75V9.174L12.1935 11.922C12.0667 11.9559 11.9333 11.9559 11.8065 11.922L1.5 9.174V6.75C1.5 6.55109 1.57902 6.36032 1.71967 6.21967C1.86032 6.07902 2.05109 6 2.25 6Z"
          fill="#2E3080"
        />
      </g>
      <defs>
        <clipPath id="clip0_429_290110">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SVGWorkHistory() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 24C6 24 4.5 24 4.5 22.5C4.5 21 6 16.5 12 16.5C18 16.5 19.5 21 19.5 22.5C19.5 24 18 24 18 24H6ZM12 15.075C12.9946 15.075 13.9484 14.6799 14.6517 13.9767C15.3549 13.2734 15.75 12.3196 15.75 11.325C15.75 10.3304 15.3549 9.37661 14.6517 8.67335C13.9484 7.97009 12.9946 7.575 12 7.575C11.0054 7.575 10.0516 7.97009 9.34835 8.67335C8.64509 9.37661 8.25 10.3304 8.25 11.325C8.25 12.3196 8.64509 13.2734 9.34835 13.9767C10.0516 14.6799 11.0054 15.075 12 15.075Z"
        fill="#2E3080"
      />
      <path
        d="M3 1.5C2.20435 1.5 1.44129 1.81607 0.87868 2.37868C0.316071 2.94129 0 3.70435 0 4.5V18.75C0 19.3467 0.237053 19.919 0.65901 20.341C1.08097 20.7629 1.65326 21 2.25 21H3.2295C3.54314 19.8977 4.08826 18.8749 4.8285 18H1.5V4.5C1.5 4.10218 1.65804 3.72064 1.93934 3.43934C2.22064 3.15804 2.60218 3 3 3H21C21.3978 3 21.7794 3.15804 22.0607 3.43934C22.342 3.72064 22.5 4.10218 22.5 4.5V18H19.1715C20.0025 18.981 20.5065 20.0595 20.7705 21H21.75C22.3467 21 22.919 20.7629 23.341 20.341C23.7629 19.919 24 19.3467 24 18.75V4.5C24 3.70435 23.6839 2.94129 23.1213 2.37868C22.5587 1.81607 21.7956 1.5 21 1.5H3Z"
        fill="#2E3080"
      />
    </svg>
  );
}

export function SVGChevron() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.47034 6.969C2.54001 6.89915 2.62277 6.84374 2.71389 6.80593C2.80501 6.76812 2.90269 6.74866 3.00134 6.74866C3.09999 6.74866 3.19767 6.76812 3.28879 6.80593C3.37991 6.84374 3.46267 6.89915 3.53234 6.969L12.0013 15.4395L20.4703 6.969C20.5401 6.89927 20.6229 6.84395 20.714 6.80621C20.8051 6.76847 20.9027 6.74905 21.0013 6.74905C21.1 6.74905 21.1976 6.76847 21.2887 6.80621C21.3798 6.84395 21.4626 6.89927 21.5323 6.969C21.6021 7.03873 21.6574 7.12151 21.6951 7.21262C21.7329 7.30373 21.7523 7.40138 21.7523 7.5C21.7523 7.59861 21.7329 7.69626 21.6951 7.78737C21.6574 7.87848 21.6021 7.96127 21.5323 8.031L12.5323 17.031C12.4627 17.1008 12.3799 17.1563 12.2888 17.1941C12.1977 17.2319 12.1 17.2513 12.0013 17.2513C11.9027 17.2513 11.805 17.2319 11.7139 17.1941C11.6228 17.1563 11.54 17.1008 11.4703 17.031L2.47034 8.031C2.4005 7.96133 2.34508 7.87857 2.30727 7.78745C2.26946 7.69633 2.25 7.59865 2.25 7.5C2.25 7.40135 2.26946 7.30366 2.30727 7.21255C2.34508 7.12143 2.4005 7.03867 2.47034 6.969Z"
        fill="#212529"
      />
    </svg>
  );
}

export function SVGSelect() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 3.75L6 8.25L10.5 3.75"
        stroke="#343A40"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SVGPerson() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C13.1935 12 14.3381 11.5259 15.182 10.682C16.0259 9.83807 16.5 8.69347 16.5 7.5C16.5 6.30653 16.0259 5.16193 15.182 4.31802C14.3381 3.47411 13.1935 3 12 3C10.8065 3 9.66193 3.47411 8.81802 4.31802C7.97411 5.16193 7.5 6.30653 7.5 7.5C7.5 8.69347 7.97411 9.83807 8.81802 10.682C9.66193 11.5259 10.8065 12 12 12ZM15 7.5C15 8.29565 14.6839 9.05871 14.1213 9.62132C13.5587 10.1839 12.7956 10.5 12 10.5C11.2044 10.5 10.4413 10.1839 9.87868 9.62132C9.31607 9.05871 9 8.29565 9 7.5C9 6.70435 9.31607 5.94129 9.87868 5.37868C10.4413 4.81607 11.2044 4.5 12 4.5C12.7956 4.5 13.5587 4.81607 14.1213 5.37868C14.6839 5.94129 15 6.70435 15 7.5ZM21 19.5C21 21 19.5 21 19.5 21H4.5C4.5 21 3 21 3 19.5C3 18 4.5 13.5 12 13.5C19.5 13.5 21 18 21 19.5ZM19.5 19.494C19.4985 19.125 19.269 18.015 18.252 16.998C17.274 16.02 15.4335 15 12 15C8.565 15 6.726 16.02 5.748 16.998C4.731 18.015 4.503 19.125 4.5 19.494H19.5Z"
        fill="#2E3080"
      />
    </svg>
  );
}

export function SVGArrowRight() {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.99917C0 4.86656 0.0526784 4.73938 0.146447 4.64561C0.240215 4.55185 0.367392 4.49917 0.5 4.49917H12.293L9.146 1.35317C9.05211 1.25928 8.99937 1.13194 8.99937 0.999167C8.99937 0.866391 9.05211 0.739053 9.146 0.645167C9.23989 0.55128 9.36722 0.498535 9.5 0.498535C9.63278 0.498535 9.76011 0.55128 9.854 0.645167L13.854 4.64517C13.9006 4.69161 13.9375 4.74679 13.9627 4.80753C13.9879 4.86828 14.0009 4.9334 14.0009 4.99917C14.0009 5.06493 13.9879 5.13005 13.9627 5.1908C13.9375 5.25154 13.9006 5.30672 13.854 5.35317L9.854 9.35317C9.76011 9.44705 9.63278 9.4998 9.5 9.4998C9.36722 9.4998 9.23989 9.44705 9.146 9.35317C9.05211 9.25928 8.99937 9.13194 8.99937 8.99917C8.99937 8.86639 9.05211 8.73905 9.146 8.64517L12.293 5.49917H0.5C0.367392 5.49917 0.240215 5.44649 0.146447 5.35272C0.0526784 5.25895 0 5.13177 0 4.99917Z"
        fill="white"
      />
    </svg>
  );
}

export function SVGQuestions() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_555_243782)">
        <path
          d="M12 22.5C9.21523 22.5 6.54451 21.3938 4.57538 19.4246C2.60625 17.4555 1.5 14.7848 1.5 12C1.5 9.21523 2.60625 6.54451 4.57538 4.57538C6.54451 2.60625 9.21523 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5ZM12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76515 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76515 1.26428 3.51472 3.51472C1.26428 5.76515 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76515 22.7357 8.8174 24 12 24Z"
          fill="#2E3080"
        />
        <path
          d="M7.8825 8.679C7.88045 8.72744 7.88832 8.77579 7.90565 8.82107C7.92297 8.86636 7.94937 8.90762 7.98323 8.94232C8.01709 8.97703 8.05769 9.00444 8.10254 9.02287C8.14738 9.0413 8.19552 9.05036 8.244 9.0495H9.4815C9.6885 9.0495 9.8535 8.88 9.8805 8.6745C10.0155 7.6905 10.6905 6.9735 11.8935 6.9735C12.9225 6.9735 13.8645 7.488 13.8645 8.7255C13.8645 9.678 13.3035 10.116 12.417 10.782C11.4075 11.5155 10.608 12.372 10.665 13.7625L10.6695 14.088C10.6711 14.1864 10.7113 14.2803 10.7814 14.3493C10.8516 14.4183 10.9461 14.457 11.0445 14.457H12.261C12.3605 14.457 12.4558 14.4175 12.5262 14.3472C12.5965 14.2768 12.636 14.1815 12.636 14.082V13.9245C12.636 12.8475 13.0455 12.534 14.151 11.6955C15.0645 11.001 16.017 10.23 16.017 8.6115C16.017 6.345 14.103 5.25 12.0075 5.25C10.107 5.25 8.025 6.135 7.8825 8.679ZM10.218 17.3235C10.218 18.123 10.8555 18.714 11.733 18.714C12.6465 18.714 13.275 18.123 13.275 17.3235C13.275 16.4955 12.645 15.9135 11.7315 15.9135C10.8555 15.9135 10.218 16.4955 10.218 17.3235Z"
          fill="#2E3080"
        />
      </g>
      <defs>
        <clipPath id="clip0_555_243782">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SVGClose() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <rect width="32" height="32" fill="white" fillOpacity="0.01" />
        <g clipPath="url(#clip0_566_261023)">
          <rect
            width="16"
            height="16"
            transform="translate(8 8)"
            fill="white"
            fillOpacity="0.01"
          />
          <g clipPath="url(#clip1_566_261023)">
            <path
              d="M8.29279 8.29217C8.48031 8.10469 8.73462 7.99938 8.99979 7.99938C9.26495 7.99938 9.51926 8.10469 9.70679 8.29217L15.9998 14.5852L22.2928 8.29217C22.385 8.19666 22.4954 8.12047 22.6174 8.06806C22.7394 8.01566 22.8706 7.98807 23.0034 7.98692C23.1362 7.98576 23.2678 8.01106 23.3907 8.06134C23.5136 8.11162 23.6253 8.18588 23.7192 8.27977C23.8131 8.37366 23.8873 8.48532 23.9376 8.60821C23.9879 8.73111 24.0132 8.86279 24.012 8.99557C24.0109 9.12835 23.9833 9.25957 23.9309 9.38157C23.8785 9.50357 23.8023 9.61392 23.7068 9.70617L17.4138 15.9992L23.7068 22.2922C23.8889 22.4808 23.9897 22.7334 23.9875 22.9956C23.9852 23.2578 23.88 23.5086 23.6946 23.694C23.5092 23.8794 23.2584 23.9846 22.9962 23.9868C22.734 23.9891 22.4814 23.8883 22.2928 23.7062L15.9998 17.4132L9.70679 23.7062C9.51818 23.8883 9.26558 23.9891 9.00339 23.9868C8.74119 23.9846 8.49038 23.8794 8.30497 23.694C8.11956 23.5086 8.01439 23.2578 8.01211 22.9956C8.00983 22.7334 8.11063 22.4808 8.29279 22.2922L14.5858 15.9992L8.29279 9.70617C8.10532 9.51864 8 9.26433 8 8.99917C8 8.734 8.10532 8.47969 8.29279 8.29217Z"
              fill="black"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_566_261023">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
        <clipPath id="clip1_566_261023">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SVGDatepicker() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" fill="white" fillOpacity="0.01" />
      <g clipPath="url(#clip0_1110_149270)">
        <rect
          width="14"
          height="14"
          transform="translate(1 1)"
          fill="white"
          fillOpacity="0.01"
        />
        <g clipPath="url(#clip1_1110_149270)">
          <path
            d="M10.4972 7.25196C10.538 7.2926 10.5703 7.34088 10.5924 7.39403C10.6144 7.44718 10.6258 7.50416 10.6258 7.56171C10.6258 7.61925 10.6144 7.67623 10.5924 7.72939C10.5703 7.78254 10.538 7.83082 10.4972 7.87146L7.87225 10.4965C7.83161 10.5372 7.78333 10.5695 7.73018 10.5916C7.67703 10.6136 7.62005 10.625 7.5625 10.625C7.50495 10.625 7.44797 10.6136 7.39482 10.5916C7.34167 10.5695 7.29339 10.5372 7.25275 10.4965L5.94025 9.18396C5.89957 9.14328 5.86731 9.09499 5.84529 9.04184C5.82328 8.9887 5.81195 8.93173 5.81195 8.87421C5.81195 8.81668 5.82328 8.75972 5.84529 8.70657C5.86731 8.65342 5.89957 8.60513 5.94025 8.56446C6.0224 8.48231 6.13382 8.43615 6.25 8.43615C6.30753 8.43615 6.36449 8.44748 6.41764 8.4695C6.47078 8.49151 6.51907 8.52378 6.55975 8.56446L7.5625 9.56808L9.87775 7.25196C9.91839 7.21121 9.96667 7.17889 10.0198 7.15683C10.073 7.13478 10.13 7.12342 10.1875 7.12342C10.245 7.12342 10.302 7.13478 10.3552 7.15683C10.4083 7.17889 10.4566 7.21121 10.4972 7.25196Z"
            fill="#6C757D"
          />
          <path
            d="M4.0625 0.999207C4.17853 0.999207 4.28981 1.0453 4.37186 1.12735C4.45391 1.20939 4.5 1.32067 4.5 1.43671V1.87421H11.5V1.43671C11.5 1.32067 11.5461 1.20939 11.6281 1.12735C11.7102 1.0453 11.8215 0.999207 11.9375 0.999207C12.0535 0.999207 12.1648 1.0453 12.2469 1.12735C12.3289 1.20939 12.375 1.32067 12.375 1.43671V1.87421H13.25C13.7141 1.87421 14.1592 2.05858 14.4874 2.38677C14.8156 2.71496 15 3.16008 15 3.62421V13.2492C15 13.7133 14.8156 14.1585 14.4874 14.4866C14.1592 14.8148 13.7141 14.9992 13.25 14.9992H2.75C2.28587 14.9992 1.84075 14.8148 1.51256 14.4866C1.18437 14.1585 1 13.7133 1 13.2492V3.62421C1 3.16008 1.18437 2.71496 1.51256 2.38677C1.84075 2.05858 2.28587 1.87421 2.75 1.87421H3.625V1.43671C3.625 1.32067 3.67109 1.20939 3.75314 1.12735C3.83519 1.0453 3.94647 0.999207 4.0625 0.999207ZM1.875 4.49921V13.2492C1.875 13.4813 1.96719 13.7038 2.13128 13.8679C2.29538 14.032 2.51794 14.1242 2.75 14.1242H13.25C13.4821 14.1242 13.7046 14.032 13.8687 13.8679C14.0328 13.7038 14.125 13.4813 14.125 13.2492V4.49921H1.875Z"
            fill="#6C757D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1110_149270">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
        <clipPath id="clip1_1110_149270">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SVGSmallArrow() {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.00002C0 3.86741 0.0526785 3.74024 0.146447 3.64647C0.240215 3.5527 0.367392 3.50002 0.5 3.50002H6.293L4.146 1.35402C4.05211 1.26013 3.99937 1.1328 3.99937 1.00002C3.99937 0.867246 4.05211 0.739908 4.146 0.646021C4.23989 0.552135 4.36722 0.49939 4.5 0.49939C4.63278 0.49939 4.76011 0.552135 4.854 0.646021L7.854 3.64602C7.90056 3.69247 7.93751 3.74764 7.96271 3.80839C7.98792 3.86913 8.00089 3.93425 8.00089 4.00002C8.00089 4.06579 7.98792 4.13091 7.96271 4.19165C7.93751 4.2524 7.90056 4.30758 7.854 4.35402L4.854 7.35402C4.76011 7.44791 4.63278 7.50065 4.5 7.50065C4.36722 7.50065 4.23989 7.44791 4.146 7.35402C4.05211 7.26013 3.99937 7.1328 3.99937 7.00002C3.99937 6.86725 4.05211 6.73991 4.146 6.64602L6.293 4.50002H0.5C0.367392 4.50002 0.240215 4.44734 0.146447 4.35358C0.0526785 4.25981 0 4.13263 0 4.00002Z"
        fill="#CED4DA"
      />
    </svg>
  );
}

export function SVGBackgroundCheck() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 4.5C21.9489 4.5 22.1397 4.57902 22.2803 4.71967C22.421 4.86032 22.5 5.05109 22.5 5.25V18.75C22.5 18.9489 22.421 19.1397 22.2803 19.2803C22.1397 19.421 21.9489 19.5 21.75 19.5H2.25C2.05109 19.5 1.86032 19.421 1.71967 19.2803C1.57902 19.1397 1.5 18.9489 1.5 18.75V5.25C1.5 5.05109 1.57902 4.86032 1.71967 4.71967C1.86032 4.57902 2.05109 4.5 2.25 4.5H21.75ZM2.25 3C1.65326 3 1.08097 3.23705 0.65901 3.65901C0.237053 4.08097 0 4.65326 0 5.25V18.75C0 19.3467 0.237053 19.919 0.65901 20.341C1.08097 20.7629 1.65326 21 2.25 21H21.75C22.3467 21 22.919 20.7629 23.341 20.341C23.7629 19.919 24 19.3467 24 18.75V5.25C24 4.65326 23.7629 4.08097 23.341 3.65901C22.919 3.23705 22.3467 3 21.75 3H2.25Z"
        fill="#2E3080"
      />
      <path
        d="M10.5 8.25C10.5 8.05109 10.579 7.86032 10.7197 7.71967C10.8603 7.57902 11.0511 7.5 11.25 7.5H18.75C18.9489 7.5 19.1397 7.57902 19.2803 7.71967C19.421 7.86032 19.5 8.05109 19.5 8.25C19.5 8.44891 19.421 8.63968 19.2803 8.78033C19.1397 8.92098 18.9489 9 18.75 9H11.25C11.0511 9 10.8603 8.92098 10.7197 8.78033C10.579 8.63968 10.5 8.44891 10.5 8.25ZM8.256 6.969C8.32584 7.03867 8.38126 7.12143 8.41907 7.21255C8.45688 7.30367 8.47634 7.40135 8.47634 7.5C8.47634 7.59865 8.45688 7.69633 8.41907 7.78745C8.38126 7.87857 8.32584 7.96133 8.256 8.031L6.006 10.281C5.93633 10.3508 5.85357 10.4063 5.76245 10.4441C5.67133 10.4819 5.57365 10.5013 5.475 10.5013C5.37635 10.5013 5.27867 10.4819 5.18755 10.4441C5.09643 10.4063 5.01367 10.3508 4.944 10.281L4.194 9.531C4.12427 9.46127 4.06895 9.37848 4.03121 9.28738C3.99348 9.19627 3.97405 9.09862 3.97405 9C3.97405 8.80084 4.05317 8.60983 4.194 8.469C4.33483 8.32817 4.52584 8.24905 4.725 8.24905C4.92416 8.24905 5.11517 8.32817 5.256 8.469L5.475 8.6895L7.194 6.969C7.26367 6.89915 7.34643 6.84374 7.43755 6.80593C7.52867 6.76812 7.62635 6.74866 7.725 6.74866C7.82365 6.74866 7.92133 6.76812 8.01245 6.80593C8.10357 6.84374 8.18633 6.89915 8.256 6.969ZM10.5 14.25C10.5 14.0511 10.579 13.8603 10.7197 13.7197C10.8603 13.579 11.0511 13.5 11.25 13.5H18.75C18.9489 13.5 19.1397 13.579 19.2803 13.7197C19.421 13.8603 19.5 14.0511 19.5 14.25C19.5 14.4489 19.421 14.6397 19.2803 14.7803C19.1397 14.921 18.9489 15 18.75 15H11.25C11.0511 15 10.8603 14.921 10.7197 14.7803C10.579 14.6397 10.5 14.4489 10.5 14.25ZM8.256 12.969C8.32584 13.0387 8.38126 13.1214 8.41907 13.2126C8.45688 13.3037 8.47634 13.4013 8.47634 13.5C8.47634 13.5987 8.45688 13.6963 8.41907 13.7874C8.38126 13.8786 8.32584 13.9613 8.256 14.031L6.006 16.281C5.93633 16.3508 5.85357 16.4063 5.76245 16.4441C5.67133 16.4819 5.57365 16.5013 5.475 16.5013C5.37635 16.5013 5.27867 16.4819 5.18755 16.4441C5.09643 16.4063 5.01367 16.3508 4.944 16.281L4.194 15.531C4.12427 15.4613 4.06895 15.3785 4.03121 15.2874C3.99348 15.1963 3.97405 15.0986 3.97405 15C3.97405 14.9014 3.99348 14.8037 4.03121 14.7126C4.06895 14.6215 4.12427 14.5387 4.194 14.469C4.26373 14.3993 4.34652 14.344 4.43762 14.3062C4.52873 14.2685 4.62638 14.2491 4.725 14.2491C4.82362 14.2491 4.92127 14.2685 5.01238 14.3062C5.10348 14.344 5.18627 14.3993 5.256 14.469L5.475 14.6895L7.194 12.969C7.26367 12.8992 7.34643 12.8437 7.43755 12.8059C7.52867 12.7681 7.62635 12.7487 7.725 12.7487C7.82365 12.7487 7.92133 12.7681 8.01245 12.8059C8.10357 12.8437 8.18633 12.8992 8.256 12.969Z"
        fill="#2E3080"
      />
    </svg>
  );
}

export function SVGTrash() {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 1.49927H8.5C8.63261 1.49927 8.75979 1.55195 8.85355 1.64571C8.94732 1.73948 9 1.86666 9 1.99927V2.99927H5V1.99927C5 1.86666 5.05268 1.73948 5.14645 1.64571C5.24021 1.55195 5.36739 1.49927 5.5 1.49927ZM10 2.99927V1.99927C10 1.60144 9.84196 1.21991 9.56066 0.938607C9.27936 0.657303 8.89782 0.499268 8.5 0.499268H5.5C5.10218 0.499268 4.72064 0.657303 4.43934 0.938607C4.15804 1.21991 4 1.60144 4 1.99927V2.99927H1.506C1.50267 2.99924 1.49933 2.99924 1.496 2.99927H0.5C0.367392 2.99927 0.240215 3.05195 0.146447 3.14571C0.0526784 3.23948 0 3.36666 0 3.49927C0 3.63188 0.0526784 3.75905 0.146447 3.85282C0.240215 3.94659 0.367392 3.99927 0.5 3.99927H1.038L1.891 14.6593C1.93122 15.1605 2.15875 15.6281 2.52827 15.9691C2.8978 16.3101 3.38219 16.4994 3.885 16.4993H10.115C10.6178 16.4994 11.1022 16.3101 11.4717 15.9691C11.8412 15.6281 12.0688 15.1605 12.109 14.6593L12.962 3.99927H13.5C13.6326 3.99927 13.7598 3.94659 13.8536 3.85282C13.9473 3.75905 14 3.63188 14 3.49927C14 3.36666 13.9473 3.23948 13.8536 3.14571C13.7598 3.05195 13.6326 2.99927 13.5 2.99927H12.505C12.5017 2.99924 12.4983 2.99924 12.495 2.99927H10ZM11.958 3.99927L11.112 14.5793C11.0919 14.8299 10.9781 15.0637 10.7934 15.2342C10.6086 15.4047 10.3664 15.4993 10.115 15.4993H3.885C3.6336 15.4993 3.3914 15.4047 3.20664 15.2342C3.02188 15.0637 2.90811 14.8299 2.888 14.5793L2.042 3.99927H11.958ZM4.471 4.99927C4.60333 4.99162 4.73329 5.03683 4.8323 5.12496C4.93131 5.2131 4.99127 5.33694 4.999 5.46927L5.499 13.9693C5.50425 14.1 5.45802 14.2277 5.37022 14.3247C5.28242 14.4218 5.16006 14.4806 5.02941 14.4884C4.89876 14.4963 4.77024 14.4526 4.67144 14.3668C4.57265 14.2809 4.51145 14.1597 4.501 14.0293L4 5.52927C3.99594 5.46358 4.00489 5.39774 4.02633 5.33552C4.04777 5.2733 4.08129 5.21592 4.12495 5.16668C4.16862 5.11744 4.22158 5.0773 4.28079 5.04858C4.34 5.01985 4.4043 5.00309 4.47 4.99927H4.471ZM9.529 4.99927C9.5947 5.00309 9.659 5.01985 9.71821 5.04858C9.77742 5.0773 9.83038 5.11744 9.87405 5.16668C9.91771 5.21592 9.95123 5.2733 9.97267 5.33552C9.99411 5.39774 10.0031 5.46358 9.999 5.52927L9.499 14.0293C9.49633 14.0957 9.48044 14.161 9.45224 14.2212C9.42405 14.2814 9.38413 14.3354 9.33481 14.38C9.28549 14.4246 9.22777 14.4589 9.16503 14.481C9.10228 14.503 9.03578 14.5123 8.9694 14.5083C8.90302 14.5043 8.8381 14.4871 8.77845 14.4577C8.7188 14.4283 8.6656 14.3874 8.62199 14.3372C8.57837 14.287 8.5452 14.2286 8.52443 14.1654C8.50365 14.1022 8.49569 14.0356 8.501 13.9693L9.001 5.46927C9.00873 5.33694 9.06869 5.2131 9.1677 5.12496C9.26671 5.03683 9.39667 4.99162 9.529 4.99927ZM7 4.99927C7.13261 4.99927 7.25979 5.05195 7.35355 5.14571C7.44732 5.23948 7.5 5.36666 7.5 5.49927V13.9993C7.5 14.1319 7.44732 14.2591 7.35355 14.3528C7.25979 14.4466 7.13261 14.4993 7 14.4993C6.86739 14.4993 6.74021 14.4466 6.64645 14.3528C6.55268 14.2591 6.5 14.1319 6.5 13.9993V5.49927C6.5 5.36666 6.55268 5.23948 6.64645 5.14571C6.74021 5.05195 6.86739 4.99927 7 4.99927Z"
        fill="#EC1C2C"
      />
    </svg>
  );
}

export function SVGEducation() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1072_300056)">
        <path
          d="M1.5 4.24194C2.8275 3.68694 4.731 3.08844 6.582 2.90244C8.577 2.70144 10.269 2.99694 11.25 4.03044V18.6494C9.8475 17.8544 8.07 17.7449 6.4305 17.9099C4.6605 18.0899 2.8755 18.6014 1.5 19.1264V4.24194ZM12.75 4.03044C13.731 2.99694 15.423 2.70144 17.418 2.90244C19.269 3.08844 21.1725 3.68694 22.5 4.24194V19.1264C21.123 18.6014 19.3395 18.0884 17.5695 17.9114C15.9285 17.7449 14.1525 17.8529 12.75 18.6494V4.03044ZM12 2.67444C10.5225 1.40394 8.3805 1.21494 6.4305 1.40994C4.1595 1.63944 1.8675 2.41794 0.4395 3.06744C0.308474 3.12703 0.197363 3.22307 0.119432 3.34409C0.0415 3.46511 3.98571e-05 3.606 0 3.74994L0 20.2499C3.4743e-05 20.3754 0.0315557 20.4989 0.0916756 20.6091C0.151796 20.7192 0.238593 20.8125 0.344116 20.8804C0.44964 20.9483 0.570517 20.9887 0.695675 20.9978C0.820833 21.0069 0.946271 20.9844 1.0605 20.9324C2.3835 20.3324 4.515 19.6109 6.5805 19.4024C8.694 19.1894 10.4655 19.5329 11.415 20.7179C11.4853 20.8055 11.5743 20.8762 11.6756 20.9248C11.7768 20.9734 11.8877 20.9986 12 20.9986C12.1123 20.9986 12.2232 20.9734 12.3244 20.9248C12.4257 20.8762 12.5147 20.8055 12.585 20.7179C13.5345 19.5329 15.306 19.1894 17.418 19.4024C19.485 19.6109 21.618 20.3324 22.9395 20.9324C23.0537 20.9844 23.1792 21.0069 23.3043 20.9978C23.4295 20.9887 23.5504 20.9483 23.6559 20.8804C23.7614 20.8125 23.8482 20.7192 23.9083 20.6091C23.9684 20.4989 24 20.3754 24 20.2499V3.74994C24 3.606 23.9585 3.46511 23.8806 3.34409C23.8026 3.22307 23.6915 3.12703 23.5605 3.06744C22.1325 2.41794 19.8405 1.63944 17.5695 1.40994C15.6195 1.21344 13.4775 1.40394 12 2.67444Z"
          fill="#2E3080"
        />
      </g>
      <defs>
        <clipPath id="clip0_1072_300056">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SVGReferences() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.07144 9.81288L5.01344 11.8709C4.16946 12.7149 3.69531 13.8596 3.69531 15.0531C3.69531 16.2467 4.16946 17.3914 5.01344 18.2354C5.85743 19.0794 7.00212 19.5535 8.19569 19.5535C9.38927 19.5535 10.534 19.0794 11.3779 18.2354L14.1199 15.4919C14.6289 14.9829 15.0083 14.3592 15.2263 13.6732C15.4444 12.9872 15.4947 12.2589 15.373 11.5495C15.2513 10.84 14.9612 10.1701 14.5271 9.59599C14.0929 9.02185 13.5274 8.56023 12.8779 8.24989L11.9989 9.12889C11.9097 9.21828 11.8321 9.31857 11.7679 9.42738C12.2697 9.57164 12.7252 9.84435 13.0893 10.2186C13.4534 10.5928 13.7135 11.0555 13.8439 11.5611C13.9744 12.0667 13.9706 12.5975 13.833 13.1012C13.6955 13.6048 13.4288 14.0639 13.0594 14.4329L10.3189 17.1749C9.75602 17.7378 8.99254 18.0541 8.19644 18.0541C7.40035 18.0541 6.63687 17.7378 6.07394 17.1749C5.51102 16.612 5.19477 15.8485 5.19477 15.0524C5.19477 14.2563 5.51102 13.4928 6.07394 12.9299L7.26344 11.7419C7.09562 11.113 7.03078 10.4625 7.07144 9.81288Z"
        fill="#2E3080"
      />
      <path
        d="M9.87794 7.00788C9.369 7.5169 8.98959 8.14058 8.77156 8.82656C8.55352 9.51255 8.50323 10.2408 8.6249 10.9503C8.74657 11.6597 9.03665 12.3296 9.4708 12.9038C9.90494 13.4779 10.4705 13.9395 11.1199 14.2499L12.2824 13.0859C11.7739 12.9495 11.3101 12.6816 10.9379 12.3092C10.5656 11.9368 10.298 11.473 10.1618 10.9643C10.0256 10.4557 10.0256 9.92016 10.162 9.41156C10.2983 8.90296 10.5661 8.4392 10.9384 8.06688L13.6789 5.32488C14.2419 4.76196 15.0054 4.44572 15.8014 4.44572C16.5975 4.44572 17.361 4.76196 17.9239 5.32488C18.4869 5.88781 18.8031 6.65129 18.8031 7.44739C18.8031 8.24348 18.4869 9.00696 17.9239 9.56988L16.7344 10.7579C16.9024 11.3879 16.9669 12.0404 16.9264 12.6884L18.9844 10.6304C19.8284 9.7864 20.3026 8.64171 20.3026 7.44813C20.3026 6.25456 19.8284 5.10987 18.9844 4.26589C18.1405 3.4219 16.9958 2.94775 15.8022 2.94775C14.6086 2.94775 13.4639 3.4219 12.6199 4.26589L9.87794 7.00788Z"
        fill="#2E3080"
      />
    </svg>
  );
}

export function SVGSubmit() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8522 0.145173C15.9214 0.214505 15.9688 0.302648 15.9883 0.398651C16.0079 0.494654 15.9988 0.594287 15.9622 0.685173L10.1432 15.2322C10.0919 15.3603 10.0063 15.4718 9.89575 15.5543C9.7852 15.6369 9.654 15.6874 9.51661 15.7002C9.37921 15.713 9.24094 15.6877 9.11702 15.627C8.99309 15.5663 8.88832 15.4726 8.81422 15.3562L5.63622 10.3612L0.641223 7.18317C0.524541 7.10916 0.430574 7.00434 0.369693 6.8803C0.308811 6.75626 0.283381 6.61781 0.296208 6.48023C0.309035 6.34264 0.359621 6.21128 0.442384 6.10063C0.525146 5.98998 0.636869 5.90434 0.765223 5.85317L15.3122 0.0361732C15.4031 -0.000414535 15.5027 -0.00949426 15.5987 0.0100619C15.6947 0.0296181 15.7829 0.0769483 15.8522 0.146173V0.145173ZM6.63422 10.0692L9.39522 14.4072L14.1282 2.57517L6.63422 10.0692ZM13.4212 1.86817L1.58922 6.60117L5.92822 9.36117L13.4222 1.86817H13.4212Z"
        fill="white"
      />
    </svg>
  );
}

export function SVGSuccessIco() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.18751 5.99915C1.18738 5.15432 1.40965 4.32434 1.83198 3.59264C2.25431 2.86094 2.86182 2.25331 3.59343 1.83084C4.32505 1.40837 5.15499 1.18593 5.99982 1.1859C6.84465 1.18587 7.67461 1.40823 8.40626 1.83065C8.50669 1.88775 8.62563 1.90281 8.73712 1.87254C8.84862 1.84227 8.94361 1.76913 9.00138 1.66908C9.05914 1.56903 9.07499 1.45019 9.04546 1.3385C9.01593 1.22681 8.94342 1.13133 8.84376 1.0729C7.75951 0.44691 6.499 0.19617 5.25773 0.359567C4.01646 0.522963 2.86378 1.09137 1.97847 1.97662C1.09315 2.86188 0.524677 4.01452 0.361201 5.25578C0.197725 6.49704 0.448385 7.75757 1.07431 8.84186C1.70023 9.92614 2.66643 10.7736 3.82307 11.2528C4.97972 11.732 6.26216 11.8162 7.47151 11.4923C8.68087 11.1683 9.74955 10.4544 10.5118 9.46126C11.2741 8.46808 11.6873 7.25113 11.6875 5.99915C11.6875 5.88312 11.6414 5.77184 11.5594 5.68979C11.4773 5.60775 11.366 5.56165 11.25 5.56165C11.134 5.56165 11.0227 5.60775 10.9406 5.68979C10.8586 5.77184 10.8125 5.88312 10.8125 5.99915C10.8125 7.27551 10.3055 8.49958 9.40296 9.4021C8.50044 10.3046 7.27636 10.8117 6.00001 10.8117C4.72365 10.8117 3.49958 10.3046 2.59706 9.4021C1.69454 8.49958 1.18751 7.27551 1.18751 5.99915Z"
        fill="#b6b7b8"
        fillOpacity="1"
      />
      <path
        d="M12.4348 1.9339C12.4754 1.89322 12.5077 1.84493 12.5297 1.79179C12.5517 1.73864 12.5631 1.68168 12.5631 1.62415C12.5631 1.56663 12.5517 1.50966 12.5297 1.45652C12.5077 1.40337 12.4754 1.35508 12.4348 1.3144C12.3941 1.27372 12.3458 1.24146 12.2926 1.21944C12.2395 1.19743 12.1825 1.1861 12.125 1.1861C12.0675 1.1861 12.0105 1.19743 11.9574 1.21944C11.9042 1.24146 11.8559 1.27372 11.8153 1.3144L6.00001 7.13053L3.68476 4.8144C3.64408 4.77372 3.59579 4.74146 3.54264 4.71944C3.4895 4.69743 3.43253 4.6861 3.37501 4.6861C3.31748 4.6861 3.26052 4.69743 3.20737 4.71944C3.15423 4.74146 3.10593 4.77372 3.06526 4.8144C3.02458 4.85508 2.99231 4.90337 2.9703 4.95652C2.94829 5.00966 2.93696 5.06663 2.93696 5.12415C2.93696 5.18168 2.94829 5.23864 2.9703 5.29179C2.99231 5.34493 3.02458 5.39322 3.06526 5.4339L5.69026 8.0589C5.7309 8.09964 5.77918 8.13197 5.83233 8.15402C5.88548 8.17608 5.94246 8.18743 6.00001 8.18743C6.05755 8.18743 6.11453 8.17608 6.16769 8.15402C6.22084 8.13197 6.26912 8.09964 6.30976 8.0589L12.4348 1.9339Z"
        fill="#b6b7b8"
        fillOpacity="1"
      />
    </svg>
  );
}
